export type SurfaceId = 'asphalt' | 'offroad' | 'concrete' | 'space' | 'sand' | 'ice' | 'snow' | 'wet' | 'mud' | 'dirt';

export interface SurfaceParams {
  id: SurfaceId;
  /** Lateral velocity damping rate (1/s). Higher sticks more. */
  grip: number;
  /** m/s² */
  accel: number;
  brake: number;
  /** m/s */
  maxSpeed: number;
  rolling: number;
  steer: number;
  dust: boolean;
}

export const SURFACES: Record<SurfaceId, SurfaceParams> = {
  asphalt: {
    id: 'asphalt',
    grip: 9.5,
    accel: 8.5,
    brake: 14,
    maxSpeed: 17.5,
    rolling: 0.55,
    steer: 1,
    dust: false,
  },
  concrete: {
    id: 'concrete',
    grip: 7.5,
    accel: 7,
    brake: 12,
    maxSpeed: 15,
    rolling: 0.7,
    steer: 0.95,
    dust: false,
  },
  offroad: {
    id: 'offroad',
    grip: 3.4,
    accel: 4.2,
    brake: 7,
    maxSpeed: 9,
    rolling: 2.4,
    steer: 0.75,
    dust: true,
  },
  space: {
    id: 'space',
    grip: 8.2,
    accel: 9.2,
    brake: 13,
    maxSpeed: 21,
    rolling: 0.35,
    steer: 1.05,
    dust: false,
  },
  sand: {
    id: 'sand',
    grip: 4.4,
    accel: 6.4,
    brake: 8,
    maxSpeed: 14.5,
    rolling: 1.45,
    steer: 0.82,
    dust: true,
  },
  ice: {
    id: 'ice',
    grip: 2.1,
    accel: 5.2,
    brake: 4.2,
    maxSpeed: 16.5,
    rolling: 0.15,
    steer: 0.48,
    dust: false,
  },
  snow: {
    id: 'snow',
    grip: 5.6,
    accel: 6.1,
    brake: 9.5,
    maxSpeed: 13.2,
    rolling: 1.05,
    steer: 0.78,
    dust: true,
  },
  wet: {
    id: 'wet',
    grip: 4.6,
    accel: 6.2,
    brake: 7.5,
    maxSpeed: 13.5,
    rolling: 0.45,
    steer: 0.62,
    dust: false,
  },
  mud: {
    id: 'mud',
    grip: 3.1,
    accel: 4.4,
    brake: 6.2,
    maxSpeed: 10.5,
    rolling: 2.7,
    steer: 0.7,
    dust: true,
  },
  dirt: {
    id: 'dirt',
    grip: 5.4,
    accel: 6.3,
    brake: 8.8,
    maxSpeed: 13.8,
    rolling: 1.35,
    steer: 0.84,
    dust: true,
  },
};

export function surfaceById(id: SurfaceId): SurfaceParams {
  return SURFACES[id];
}
